import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';

import Message from '../Message';
import Button from '../Button';

import './styles.css';

const messages = defineMessages({
  actionableMessageAction: {
    id: 'actionable.message.action',
    defaultMessage: 'Learn More',
  },
});

const ActionableMessage = ({ action, message, instructions }) => {
  if (!action) {
    return (
      <Message styleName="message-container">
        <FormattedMessage tagName="div" {...message} />
        <strong><FormattedMessage tagName="div" {...instructions} /></strong>
      </Message>
    );
  } else {
    return (
      <Message styleName="message-container message-flex-container">
        <div styleName="message-flex-content-block">
          <FormattedMessage tagName="div" {...message} />
          <strong><FormattedMessage tagName="div" {...instructions} /></strong>
        </div>
        <div styleName="message-flex-action-block">
          <Button inverted size="small" onClick={action}>
            <FormattedMessage {...messages.actionableMessageAction} />
          </Button>
        </div>
      </Message>
    );
  }
};

ActionableMessage.propTypes = {
  action: PropTypes.func,
  message: PropTypes.object.isRequired,
  instructions: PropTypes.object.isRequired,
};

export default ActionableMessage;
